const contextPath = "";

const paths = {
    // ログイン
    login: contextPath + '/login',
    // TOPメニュー
    top: contextPath + '/',
    // 企業情報
    company: contextPath + '/company/detail',
    companyChange: contextPath + '/company/update',
    // 回線一覧
    line: contextPath + '/line',
    // 回線詳細
    lineDetail: contextPath + '/line/detail/:number',
    lineDetailForPush: contextPath + '/line/detail/',
    // 回線解約申込
    lineCancel: contextPath + '/line/terminate/:lineId',
    lineCancelForPush: contextPath + '/line/terminate/', 
    // 回線オプション追加
    optinonAdd: contextPath + '/line/add-option/:lineId/:option',
    optinonAddForPush: contextPath + '/line/add-option/',
    // 回線オプション解約
    optinonCancel: contextPath + '/line/cancel-option/:lineId/:option',
    optinonCancelForPush: contextPath + '/line/cancel-option/',
    // ご利用料金確認
    usage: contextPath + '/usage-fee',
    usageDetail: contextPath + '/usage-fee/detail/:settlementMonth',
    usageDetailForPush: contextPath + '/usage-fee/detail/',
    // 担当者情報
    employee: contextPath + '/employee',
    employeeAdd: contextPath + '/employee/add',
    employeeUpdate: contextPath + '/employee/update/:id',
    employeeUpdateForPush: contextPath + '/employee/update/',
    // アカウント、パスワード変更
    account: contextPath + '/account',
    passwordUpdate: contextPath + '/account/update',
    // パスワード初期化
    passwordSendMail: contextPath + '/password/reset',
    resetPassword: contextPath + '/password/init',
    // ステムエラー
    error: contextPath + '/error',}
    Object.freeze(paths);

const roles = {
    admin: 'ROLE_SELF_ADMIN',
    user: 'ROLE_SELF_USER',
}
Object.freeze(roles);

const bl = {
    user: [roles.user],
    // いる？
    all: Object.values(roles),
    nothing: [],
}
Object.freeze(bl);

export {
    paths,
    roles,
    bl,
}
